
import Vue from 'vue'
import ProjectMixin from '@/_mixins/project'

import { getRequest } from '@/plugins/api-axios'
import { deserialise } from 'kitsu-core'

import { PSI } from '@/views/Project/PSI/types/psi'

import PsiCard from '@/views/Project/PSI/components/psiCard.vue'

const Psis = Vue.extend({
    mixins: [ProjectMixin],
    components: { PsiCard },
    data() {
        return {
            infiniteId: 0,
            offset: 0,
            limit: 20,
            psis: [] as Array<PSI>,
            psiToRevisions: {},
        }
    },

    watch: {
        currentProjectId: {
            immediate: true,
            handler() {
                this.offset = 0
                this.infiniteId = Date.now()
                this.psis = []
            },
        },
    },

    methods: {
        async loadPSIs($state: any) {
            let { data } = await getRequest(
                this.getURL({
                    path: `psis`,
                    base: this.psiBaseUrl,
                    params: {
                        ...(this.isProject && { 'filter[project]': this.currentProject.id }),
                        ...(!this.isProject && { 'filter[projectGroup]': this.currentGroup.id }),
                        'filter[isArchived]': false,
                        'page[limit]': this.limit,
                        'page[offset]': this.offset,
                        include: 'myCompletions',
                    },
                }),
                this.getRequestHeaders('GET')
            )

            let res = deserialise(data).data
            await this.getForms(res.map(({ id }) => id))
            this.psis = [...this.psis, ...res]
            if (res.length == this.limit) {
                $state.loaded()
                this.offset += this.limit
            } else {
                $state.complete()
            }
        },
        async getForms(psiIds: Array<string | undefined>) {
            let { data } = await getRequest(
                this.getURL({
                    path: `forms`,
                    base: this.formBaseUrl,
                    params: {
                        'filter[resource]': psiIds.filter(Boolean).join(','),
                        'page[limit]': 100,
                        include: 'resource,activeRevision',
                    },
                }),
                this.getRequestHeaders('GET')
            )
            let formData = deserialise(data).data
            formData.forEach((form) => {
                this.$set(this.psiToRevisions, form.resource.data.id, {
                    id: form.id,
                    data: this.flattenRevisions(form),
                })
            })
        },

        async refreshFormRevisions(resourceId) {
            if (resourceId) {
                await this.getForms([resourceId])
            }
        },

        flattenRevisions(data: any) {
            let revisions: any[] = []

            if (data.activeRevision.data) {
                revisions.push({ ...data.activeRevision.data, _status: 'active' })
            }

            return revisions
        },

        async loadPSI(index: number, psi: PSI) {
            let { data } = await getRequest(
                this.getURL({
                    path: `psis/${psi.id}`,
                    base: this.psiBaseUrl,
                    params: {
                        include: 'myCompletions',
                    },
                })
            )

            let res = deserialise(data).data
            this.psis.splice(index, 1, res)
        },
    },
})

export default Psis
